export const ROUTES = {
  HOME: '/',
  OTP: '/otp/',
  PROFILE: '/profile',
  SUBSCRIPTIONS: '/subscriptions',
  SUBSCRIPTIONS_WITH_CANCELED: '/subscriptions?status=cancel',
  REASONS: '/reasons/',
  TERMS: 'https://sites.google.com/view/fit4me-app/terms-of-use?authuser=0',
  FAQ: 'https://support.fit4me.io/support',
  PRIVACY_POLICY: 'https://sites.google.com/view/fit4me-app/privacy-policy?authuser=0',
  MONEY_BACK: 'https://sites.google.com/view/fit4me-app/refund-policy?authuser=0',
  OFFER: '/offer',
  OFFER_WITH_PARAMS: ({ endDate }: { endDate: string }) => `/offer?endDate=${endDate}`,
  LOGIN: '/login',
  MEALS_RECOMMENDATIONS:
    'https://sites.google.com/view/fit4me-app/meals-recommendations?authuser=0',
} as const
